/*!
 * Lazy Load - JavaScript plugin for lazy loading images
 *
 * Copyright (c) 2007-2019 Mika Tuupola
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Project home:
 *   https://appelsiini.net/projects/lazyload
 *
 * Version: 2.0.0-rc.2
 *
 */

window.loadedImages = [];
window.lazyloadEvents = false;

(function (root, factory) {
    if (typeof exports === "object") {
        module.exports = factory(root);
    } else if (typeof define === "function" && define.amd) {
        define([], factory);
    } else {
        root.LazyLoad = factory(root);
    }
}) (typeof global !== "undefined" ? global : this.window || this.global, function (root) {

    "use strict";

    if (typeof define === "function" && define.amd){
        root = window;
    }

    var defaults = {
        src: "data-src",
        srcretina: "data-src-retina",
        srcset: "data-srcset",
        selector: ".lazyload",
        root: null,
        rootMargin: "300px",
        threshold: 0
    };

    /**
    * Merge two or more objects. Returns a new object.
    * @private
    * @param {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
    * @param {Object}   objects  The objects to merge together
    * @returns {Object}          Merged values of defaults and options
    */
    var extend = function ()  {

        var extended = {};
        var deep = false;
        var i = 0;
        var length = arguments.length;

        /* Check if a deep merge */
        if (Object.prototype.toString.call(arguments[0]) === "[object Boolean]") {
            deep = arguments[0];
            i++;
        }

        /* Merge the object into the extended object */
        var merge = function (obj) {
            for (var prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    /* If deep merge and property is an object, merge properties */
                    if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]") {
                        extended[prop] = extend(true, extended[prop], obj[prop]);
                    } else {
                        extended[prop] = obj[prop];
                    }
                }
            }
        };

        /* Loop through each object and conduct a merge */
        for (; i < length; i++) {
            var obj = arguments[i];
            merge(obj);
        }

        return extended;
    };

    function LazyLoad(images, options) {
        this.settings = extend(defaults, options || {});
        this.images = images || document.querySelectorAll(this.settings.selector);
        this.observer = null;
        this.init();
    }

    LazyLoad.prototype = {
        init: function() {

			// Events
			if ( !window.lazyloadEvents ) {
				var x = this;
				window.lazyloadEvents = true;
				$( 'body' ).on( 'preload_images', function() {
					x.preloadImages();
				});
			}

            /* Without observers load everything and bail out early. */
            if (!root.IntersectionObserver) {
                this.loadImages();
                return;
            }

            var self = this;
            var observerConfig = {
                root: this.settings.root,
                rootMargin: this.settings.rootMargin,
                threshold: [this.settings.threshold]
            };

            this.observer = new IntersectionObserver(function(entries) {
                Array.prototype.forEach.call(entries, function (entry) {
                    if (entry.isIntersecting) {
                        self.observer.unobserve(entry.target);
                        var src = entry.target.getAttribute(self.settings.src);
                        var srcretina = entry.target.getAttribute(self.settings.srcretina);
                        var srcset = entry.target.getAttribute(self.settings.srcset);

						if ( srcretina != null ) {
							if ( !isRetinaDisplay() || ( typeof window.catID != 'undefined' && isMobileDevice() ) ) {
								srcretina = false;
							}
						}

                        if ("img" === entry.target.tagName.toLowerCase()) {
                            if (srcretina ) {
                                entry.target.src = srcretina;
								window.loadedImages.push( srcretina );
                            } else {
                                if (src) {
                                    entry.target.src = src;
									window.loadedImages.push( src );
                                }
                            }
                            if (srcset) {
                                entry.target.srcset = srcset;
                            }
                        } else {
                            if ( srcretina ) {
                                entry.target.style.backgroundImage = "url(" + srcretina + ")";
								window.loadedImages.push( srcretina );
                            } else {
                                entry.target.style.backgroundImage = "url(" + src + ")";
								window.loadedImages.push( src );
                            }
                        }
                    }
                });
            }, observerConfig);

			Array.prototype.forEach.call(this.images, function (image) {
                self.observer.observe(image);
            });
        },

        loadAndDestroy: function () {
            if (!this.settings) { return; }
            this.loadImages();
            this.destroy();
        },

        loadImages: function () {
            if (!this.settings) { return; }

            var self = this;
            Array.prototype.forEach.call(this.images, function (image) {
                var src = image.getAttribute(self.settings.src);
                var srcretina = image.getAttribute(self.settings.srcretina);
                var srcset = image.getAttribute(self.settings.srcset);

				if ( srcretina != null ) {
					if ( !isRetinaDisplay() || ( typeof window.catID != 'undefined' && isMobileDevice() ) ) {
						srcretina = false;
					}
				}

				if ("img" === image.tagName.toLowerCase()) {
					if (srcretina ) {
						image.src = srcretina;
						window.loadedImages.push( srcretina );
					} else {
						if (src) {
							image.src = src;
							window.loadedImages.push( src );
						}
					}
					if (srcset) {
						image.srcset = srcset;
					}
				} else {
					if ( srcretina ) {
						image.style.backgroundImage = "url(" + srcretina + ")";
						window.loadedImages.push( srcretina );
					} else {
						image.style.backgroundImage = "url(" + src + ")";
						window.loadedImages.push( src );
					}
				}

            });
        },

        preloadImages: function () {
            if (!this.settings) { return; }

			var self = this;
            Array.prototype.forEach.call(this.images, function (image) {
                var src = image.getAttribute(self.settings.src);
                var srcretina = image.getAttribute(self.settings.srcretina);

				if ( srcretina != null ) {
					if ( !isRetinaDisplay() || ( typeof window.catID != 'undefined' && isMobileDevice() ) ) {
						srcretina = false;
					}
				}

				if ("img" === image.tagName.toLowerCase()) {
					if (srcretina ) {
						if ( window.loadedImages.indexOf( srcretina ) == -1 ) {
							var im = new Image();
							im.src = srcretina;
							window.loadedImages.push( srcretina );
						}
					} else {
						if (src) {
							if ( window.loadedImages.indexOf( src ) == -1 ) {
								var im = new Image();
								im.src = src;
								window.loadedImages.push( src );
							}
						}
					}
				} else {
					if ( srcretina ) {
						if ( window.loadedImages.indexOf( srcretina ) == -1 ) {
							var im = new Image();
							im.src = srcretina;
							window.loadedImages.push( srcretina );
						}
					} else {
						if ( window.loadedImages.indexOf( src ) == -1 ) {
							var im = new Image();
							im.src = src;
							window.loadedImages.push( src );
						}
					}
				}
            });
        },

        destroy: function () {
            if (!this.settings) { return; }
            this.observer.disconnect();
            this.settings = null;
        }
    };

    root.lazyload = function(images, options) {
        return new LazyLoad(images, options);
    };

    if (root.jQuery) {
        var $ = root.jQuery;
        $.fn.lazyload = function (options) {
            options = options || {};
            options.attribute = options.attribute || "data-src";
            new LazyLoad($.makeArray(this), options);
            return this;
        };
    }

    return LazyLoad;
});
